import { Link } from 'react-router-dom';
import { useInquiry } from '../context/InquiryContext';
import ImageWithSkeleton from './ImageWithSkeleton';

const API_BASE = (import.meta.env.VITE_API_URL ?? "http://localhost:8000/storage").replace(/\/api$/, "");

function resolveUrl(img) {
  if (!img) return null;
  const src = typeof img === "object" ? (img.image || img.url) : img;
  if (!src) return null;
  if (src.startsWith("http") || src.startsWith("data:") || src.startsWith("/")) {
    return src;
  }
  return `${API_BASE}/${src}`;
}

function getProductImages(product) {
  let first = product.img1 || product.primary_image;
  let second = product.img2;

  const imagesArr = product.images || [];

  if (!first && imagesArr.length > 0) {
    const primaryObj = imagesArr.find((i) => i.is_primary) || imagesArr[0];
    first = primaryObj;
  }

  if (!second && imagesArr.length > 1) {
    const secondObj = imagesArr.find((i) => !i.is_primary) || imagesArr[1];
    second = secondObj;
  }

  const firstUrl = resolveUrl(first) || "/img/product/placeholder.jpg";
  const secondUrl = resolveUrl(second);
  const hasSecondImage = Boolean(secondUrl && secondUrl !== firstUrl);

  return { firstUrl, secondUrl: hasSecondImage ? secondUrl : firstUrl, hasSecondImage };
}

export default function ProductCard({ product }) {
  const { openInquiry } = useInquiry();
  const { firstUrl, secondUrl, hasSecondImage } = getProductImages(product);

  return (
    <div className="group relative border border-border-color overflow-hidden bg-white h-[320px]">
      <Link to={`/product-details/${product.product_id}`} className="block relative h-56 overflow-hidden">
        {/* Primary Image Wrapper */}
        <div className={`w-full h-full transition-opacity duration-300 ${hasSecondImage ? "group-hover:opacity-0" : ""}`}>
          <ImageWithSkeleton
            src={firstUrl}
            alt={product.name}
            containerClassName="w-full h-full"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Secondary Image Wrapper */}
        {hasSecondImage && (
          <div className="absolute inset-0 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <ImageWithSkeleton
              src={secondUrl}
              alt={product.name}
              containerClassName="w-full h-full"
              className="w-full h-full object-cover"
            />
          </div>
        )}

        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openInquiry(product);
          }}
          className="absolute left-1/2 -translate-x-1/2 bottom-4 md:translate-y-12 translate-y-0 md:opacity-0 opacity-100
                     md:group-hover:translate-y-0 md:group-hover:opacity-100
                     transition-all duration-300 ease-out
                     bg-white/95 text-dark text-xs font-semibold tracking-wide uppercase
                     px-5 py-2.5 shadow-md btn-readmore hover:text-black w-[85%] md:w-auto text-center"
        >
          Send Enquiry
        </button>
      </Link>

      <div className="p-3 text-center">
        <p className="text-[11px] text-gray-400 uppercase">{product.category?.name ?? ''}</p>
        <Link to={`/product-details/${product.product_id}`}>
          <h3 className="text-sm font-medium text-dark mt-1 line-clamp-2 hover:text-primary">
            {product.name}
          </h3>
        </Link>
        {/* <div className="mt-1 flex justify-center items-center gap-2">
          <span className="text-primary font-bold text-sm">₹{product.price}.00</span>
          {product.old_price && (
            <span className="text-gray-400 text-xs line-through">₹{product.old_price}.00</span>
          )}
        </div> */}
      </div>
    </div>
  );
}